// extracted by mini-css-extract-plugin
module.exports = {"container":"BillImageCard_container_1Hv2E","overlay":"BillImageCard_overlay_1OB2s"};